import { useQuery } from '@tanstack/react-query';

import { BatchListItem } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useBatch = (id: string) =>
  useQuery({
    queryKey: ['batch', id],
    queryFn: async (): Promise<BatchListItem> => {
      try {
        const result = await apiClient.batchesCore.getBatch.query({ params: { id } });
        if (result.status !== 200) throw result.body;

        return result.body.data.batch;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch the batch details');
      }
    },
    enabled: !!id,
  });
